import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


type Props = {
    rows: number,
};

export const TreeSkeleton = ({rows}: Props) => (
    <FormItemSkeleton labelWidth={100}>
        <Group direction="v" alignItems="start" gap="s">
            {new Array(rows).fill(0).map((_, index) => {
                return (
                    <SkeletonItem key={index} width={200} height={18}/>
                );
            })}
        </Group>
    </FormItemSkeleton>
);
